import { render, staticRenderFns } from "./RealtimeDiskMonitor.vue?vue&type=template&id=b5d6efce&"
import script from "./RealtimeDiskMonitor.vue?vue&type=script&lang=js&"
export * from "./RealtimeDiskMonitor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports